import { render, staticRenderFns } from "./WorkforceInviteButton.vue?vue&type=template&id=36b6b05e&scoped=true"
import script from "./WorkforceInviteButton.vue?vue&type=script&lang=js"
export * from "./WorkforceInviteButton.vue?vue&type=script&lang=js"
import style0 from "./WorkforceInviteButton.vue?vue&type=style&index=0&id=36b6b05e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b6b05e",
  null
  
)

export default component.exports